import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { TeacherProfileComponent } from '../teacher-profile/teacher-profile.component';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

@Component({
  selector: 'app-teacher-data',
  templateUrl: './teacher-data.component.html',
  styleUrls: ['./teacher-data.component.scss']
})
export class TeacherDataComponent implements OnInit {
  teacherSearchForm: FormGroup;
  userPermission: any;
  UserFaculty: any;
  isClgLogin: boolean = sessionStorage.getItem('TLoginName') !== 'admin';
  TstatusList: any[] = [];
  filterTstatusList: any[] = [];

  constructor(
    public umsService: UmsService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) { }

  TeachersDataList: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  setIntervalSearch: any;
  UserCollege: any;
  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));

    this.teacherSearchForm = this.fb.group({
      SearchString: new FormControl(''),
      TeacherStatus: new FormControl('')   
    });

    this.getteacherdata();
    this.getAllDData();
    this.fetchTeachersStatusList();        
  }

  fetchTeachersStatusList() {
    const payload = {};
    payload['CdType'] = 'TS';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.TstatusList = res.data;
        this.filterTstatusList = this.TstatusList.slice();
      } else {
        // handle error silently
      }
    });
  }

  getteacherdata() {
    if (this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;


    }
    else {
      this.UserCollege = '';
      // this.UserFaculty = '';
    }
    this.UserFaculty = this.userPermission[0].FcCode;
    console.log('this.userPermission[0]', this.userPermission[0]);
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['CgCode'] = this.UserCollege;
    payload['FcCode'] = this.isClgLogin ? this.UserFaculty : '';
    payload['TeacherStatus'] = this.teacherSearchForm.value.TeacherStatus;
    this.umsService.getTeachersData(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.TeachersDataList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      } else {
        this.spinner.hide();
      }
    });
  }

  addnewrecord() {
    const dialogRef = this.dialog.open(TeacherProfileComponent, {
      width: 'auto',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getteacherdata();
      // this.FacultySearchForm.controls['FcCode'].setValue('');
    });
  }

  editData(data) {
    const dialogRef = this.dialog.open(TeacherProfileComponent, {
      width: 'auto',
      data: { selected: data, key: "Edit" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getteacherdata();
      // this.FacultySearchForm.controls['FcCode'].setValue('');
    });
  }
  deleteData(data) {
    const dialogRef = this.dialog.open(TeacherProfileComponent, {
      width: 'auto',
      data: { selected: data, key: "Delete" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getteacherdata();
      // this.FacultySearchForm.controls['FcCode'].setValue('');
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getteacherdata();
    // this.keypress()
  }


  keypress() {
    if (this.setIntervalSearch) {
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(() => {
      this.TeachersDataList = [];
      this.UserFaculty = this.userPermission[0].FcCode;
      const payload = {};
      payload['PageSize'] = this.pageSize;
      payload['SearchString'] = this.teacherSearchForm.value['SearchString'];
      payload['FcCode'] = this.isClgLogin ? this.UserFaculty : '';
      if (payload['SearchString'] === "" && !this.teacherSearchForm.value.TeacherStatus) {
        payload['PageNumber'] = this.currentPage;
      } else {
        payload['PageNumber'] = 1;
      }
      payload['CgCode'] = this.UserCollege;
      payload['TeacherStatus'] = this.teacherSearchForm.value.TeacherStatus;
      this.umsService.getTeachersData(payload).subscribe(
        (res) => {
          if (res.status) {
            this.TeachersDataList = res.data;
            this.totalItems = res.data[0].TotalRecords;
          }
          else {
            this.TeachersDataList = [];
            this.totalItems = 0
          }

        }, (ERROR: HttpErrorResponse) => {
          this.TeachersDataList = [];
          this.totalItems = 0
        });
    }, 1000)


  }

  getAllDData() {
    if (this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    }
    else {
      this.UserCollege = '';
    }
    this.UserFaculty = this.userPermission[0].FcCode;
    console.log('this.userPermission[0]', this.userPermission[0]);
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['CgCode'] = this.UserCollege;
    payload['FcCode'] = this.isClgLogin ? this.UserFaculty : '';
    payload['TeacherStatus'] = this.teacherSearchForm.value.TeacherStatus;
    this.umsService.getTeachersData(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.TeachersDataList = res.data;
      } else {
        this.spinner.hide();
      }

    })
  }
       getStatusDescription(statusCode: string): string {
    if (!statusCode || !this.TstatusList) return statusCode;
    const found = this.TstatusList.find(item => item.CdCode === statusCode);
    return found ? found.CdDesc : statusCode;
  }


  download2(event: Event) {
    event.preventDefault();
    const extractedData = this.TeachersDataList.map(element => ({
      P_NO: element.StuRgNo,
      StuID: element.StuId,
      Name: element.StudentName,
      AttendCount: element.AttendCount,
      Branch: element.EsStrId,
      ScrutinyID: 0,
    }));

    // Convert array data to CSV format
    const csvContent = this.convertArrayToCSV(extractedData);
    // Create a Blob
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'TeacherData.csv'; // You can change the file name if needed
    document.body.appendChild(link);
    link.click();
  }

  convertArrayToCSV(array) {
    const header = Object.keys(array[0]).join(',');
    const rows = array.map(obj => Object.values(obj).map(value => `"${value}"`).join(','));
    return [header, ...rows].join('\n');
  }

  downloadTeacherData() {
    this.spinner.show();

    const payload: any = {
      CgCode: this.userPermission[0].CgUi == 'C' ? this.userPermission[0].CgId : '',
      FcCode: this.isClgLogin ? this.userPermission[0].FcCode : '',
      PageSize: 100000,   
      PageNumber: 1  
    };

    this.umsService.getTeachersData(payload).subscribe((res: any) => {
      this.spinner.hide();

      if (!res.status || !res.data || res.data.length === 0) {
        alert('No teacher data available to download!');
        return;
      }

      const allData = res.data;

      const selectedData = allData.map((t, index) => ({
        'Row No': index + 1,
        'Initial': t.Initial || '',
        'First Name': t.FirstName || '',
        'Middle Name': t.MiddleName || '',
        'Last Name': t.LastName || '',
        'Full Name': t.FullName || '',
        'Gender': t.Gender || '',
        'Date of Birth': t.DOB ? new Date(t.DOB).toLocaleDateString() : '',
        'PAN No': t.PANNo || '',
        'OSAC ID': t.OSACID || '',
        'Taught Subject': t.SubjectNames || '',
        'PG Qualification Year': t.PGQualiPassYear || '',
        'PG Guide': t.Guide ? 'Yes' : 'No',
        'PhD Guide': t.PhdGuide ? 'Yes' : 'No',
        'Debar': t.Debar ? 'Yes' : 'No',
        'College Code': t.CgCode || '',
        'College': t.CgName || '',
        'Faculty': t.FcCode || '',
        'Department': t.DeptCode || '',
        'Department Name': t.DeptName || '',
        'Designation': t.DesignationName || '',
        'HOD': t.isHOD ? 'Yes' : 'No',
        'Approve Status PG': t.ApprovalStPG ? 'Yes' : 'No',
        'Approve Status UG': t.ApprovalStUG ? 'Yes' : 'No',
        'UG Exp (Years)': t.UGExpYears || '',
        'UG Exp (Months)': t.UGExpMonths || '',
        'UG Exp (Days)': t.UGExpDays || '',
        'PG Exp (Years)': t.PGExpYears || '',
        'PG Exp (Months)': t.PGExpMonths || '',
        'PG Exp (Days)': t.PGExpDays || '',
        'Mobile No': t.MobileNo || '',
        'Email': t.Email || '',
        'Aadhar No': t.AadharNo || ''
      }));

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(selectedData);
      const workbook: XLSX.WorkBook = {
        Sheets: { 'Examiner Data': worksheet },
        SheetNames: ['Examiner Data']
      };
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const data: Blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      });
      saveAs(data, 'Examiner_Data_' + new Date().toISOString().slice(0, 10) + '.xlsx');
    },
      (error) => {
        this.spinner.hide();
        console.error('Error downloading teacher data:', error);
        alert('Something went wrong while downloading data!');
      });
  }


  // downloadTeacherData() {
  //   if (!this.TeachersDataList || this.TeachersDataList.length === 0) {
  //     alert('No teacher data available to download!');
  //   return;
  // }

  //   // Convert teacher data to worksheet
  //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.TeachersDataList);

  //   // Create workbook
  //   const workbook: XLSX.WorkBook = {
  //     Sheets: { 'Teacher Data': worksheet },
  //     SheetNames: ['Teacher Data']
  // };

  //   // Generate Excel file buffer
  //   const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

  //   // Save file
  //   const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
  //   saveAs(data, 'Teacher_Data_' + new Date().toISOString().slice(0, 10) + '.xlsx');
  // }
}
